var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconApi = function SvgIconApi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M7,8h34c2.21,0,4,1.791,4,4v24c0,2.209-1.79,4-4,4H7c-2.209,0-4-1.791-4-4V12C3,9.791,4.791,8,7,8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M17.038,28.725h-4.292L11.909,32H8.581l4.87-16h2.88l4.903,16h-3.361L17.038,28.725z M13.431,26.033h2.912l-1.456-5.703L13.431,26.033z M26,26.374V32h-3V16h5c1.542,0,2.771,0.491,3.689,1.473C32.605,18.454,33,19.729,33,21.297s-0.39,2.806-1.295,3.714c-0.907,0.908-2.163,1.363-3.768,1.363H26z M26,23.681h2.116c0.599,0,1.063-0.201,1.393-0.604C29.836,22.674,30,22.088,30,21.319c0-0.799-0.167-1.434-0.503-1.907c-0.335-0.472-0.785-0.712-1.349-0.72H26V23.681z M38,32h-3V16h3V32z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconApi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_api.393fddaf.svg";
export { ForwardRef as ReactComponent };